module.exports = __webpack_public_path__ + "media/images/pic/testimonials/awatar-11-451387bc8836cdefc05a03467d627dc9.svg";